import React from 'react';
import { Modal } from 'bootstrap';
import { connect } from 'react-redux';
import swal from "sweetalert"
import Loader from "../../../components/ui/Loader/Loader";
import Ax from "../../../components/hoc/Ax";
import { DisplayListPagination, DisplaySearchCriteria, PeriodSelectionWithCustom } from '../../../components/TapUi';
import ApplicationLayout from '../../../layouts/ApplicationLayout';
import AppBaseComponent from '../../../components/AppBaseComponent';
import tapIcon from '../../../services/TapIcon';
import { Helmet } from 'react-helmet';
import { IAM_API_BASE_URL_2, IAM_SUBASSEMBLY_URL } from '../../../services/TapApiUrls';
import HttpAPICall from '../../../services/HttpAPICall';
import { toast } from 'react-toastify';
import TapSelect from '../../../components/ui/TapSelect';
import moment from 'moment';
import Status from '../../../components/ui/Status';
import { Link } from 'react-router-dom';
import DatePicker from "react-datepicker";
import TapIcon from '../../../services/TapIcon';
import DateService from '../../../services/DateService';
import SubAssemblyDetail from './SubAssemblyDetail';
import InputAssetSearch from '../../includes/ui/InputAssetSearch';
import LinkingModal from './LinkingModal';
import DownloadFile from "../../../services/DownloadFile";
import api from '../../../services/api';


class SubAssemblyList extends AppBaseComponent {

    constructor(props) {
        super(props);
    
        this.subAssemblySearchInitState =   {
            'search_name'                   :   '',
            'search_card_number'            :   '', 
            'search_category_id'            :   '',  
            'search_serial_number'          :   '',
            'search_site_ids'               :   [],
            'search_asset_ids'              :   [],
            'search_status_ids'             :   [],
            'search_linking_status'         :   '',
            'search_tags'                       :   [],

        };

        this.subAssemblySearchFormLabel =   {
            'search_name'                   :   'Name : ',
            'search_card_number'            :   'Code : ',
            'search_serial_number'          :   'Serial Number : ',
            'search_site_ids'               :   'Sites : ',
            'search_asset_ids'              :   'Assets : ',
            'search_status_ids'             :   'Status : ',
            'search_category_id'            :   'Category : ',
            'search_linking_status'         :   'Linking Status : ',
            'search_tags'                   :   'Tags : ',

        };

        this.executeFormInit            =       {
            odometer                     :       '',
            operation_cycle               :       '',
            hourmeter                     :       '',
            date_time                     :       '',
            hourmeter2                    :       '' , 
            hourmeter3                    :       '' , 
            hourmeter4                    :       '' ,
            odometer2                    :       '',
            odometer3                    :       '',
            operation_cycle2              :       '',
          }

        this.changeSiteTranstionFormInit        =       {
            site_since_date                     :       "",
        }

        this.changeStatusFormInit               =   {
            status_id                               :   "",
            status_since_date                       :   "",
            remark                                  :   "",
        };
        this.bulkChangeStatusFormInit = {
            status_id: "",
            status_since_date: "",
            remark: "",
        };

        this.changeSiteFormInit               =   {
            site_id                               :   "",
            remark                                :   "",
            transfer_date                         :   "",
        }; 
        this.bulkChangeSiteFormInit = {
          site_id: "",
          transfer_date: "",
          remark: "",
        };
        this.linkAssetFormInit               =   {
           name                             :       "",
           remark                           :       "",
           odometer                     :       '',
           operation_cycle               :       '',
           hourmeter                     :       '',
           date_time                     :       '',
           hourmeter2                    :       '' , 
           hourmeter3                    :       '' , 
           hourmeter4                    :       '' ,
           odometer2                    :       '',
           odometer3                    :       '',
           operation_cycle2              :       '',
           date_time                    :       '',
           linked_hour_meter            :       '',
           linked_odo_meter             :       '',
           linked_opc                   :       ''
        };  

        this.state                      =   {  
            minimizeTable                   :   false,   
            listing_loading                 :   false,
            listing_tbl_page                :   1,
            sub_assembly_listing            :   [],
            listingMeta                     :   null,
            totalListingCount               :   0,

            subAssemblySearchForm           :   {...this.subAssemblySearchInitState},
            submittedSubAssemblySearchForm  :   {...this.subAssemblySearchInitState},
            file_downloading                :   false,
            viewDataLoading                 :   false,
            access_token                    :   '',
            assetBulkUploadFormSubmiting    : false,

            formSearchedElems               :   [],
            allStatus                       :   [],
            subAssemblyCategories           :   [],
            subAssemblyTags                 :   [],
            siteList                        :   [],
            changeStatusForm                :   {...this.changeStatusFormInit},
              bulkChangeStatusForm: {...this.bulkChangeStatusFormInit},
             isBulkStatusChange: false,
            changeSiteForm                  :   {...this.changeSiteFormInit},
            bulkChangeSiteForm: {...this.bulkChangeSiteFormInit},
            isBulkSiteChange: false, 
            linkAssetForm                   :   {...this.linkAssetFormInit},
            countelogForm                   :   {...this.executeFormInit},
            
            saveFormSubmitting              :   false,
            subAssemblyId                   :   '',
            subAssemblyDetail               :   null,
            searchedAssets                  :   [],
            linkedAsset                     :   null,
            assetDetail                     :   null,
            proceedForm                     :   false,
            enable_hour_meter               :   'N',
            enable_odo_meter               :   'N',
            enable_opc                     :   'N',
            currentActionType               :   '',
            linkingStatus                    :   [],
           criteriaHeight                  :        0,
           subAssemblyTags                  :   [], 

        };
        this.criteriaRef                    = React.createRef();
        this.viewLoadData           =   React.createRef();
        this.changeStatusModal      =   React.createRef();
        this.changeSiteModal        =   React.createRef();
        this.searchModal            =   React.createRef();
        this.linkAssetModalRef      =   React.createRef();
    }
    
    
    componentDidMount() {
        this.initilaizeFilterFormData(this.props);
        this.changeStatusModal      =   new Modal(document.getElementById('changeStatusModal'), {keyboard: false, backdrop :false});
        this.changeSiteModal        =   new Modal(document.getElementById('changeSiteModal'), {keyboard: false, backdrop :false});
        this.searchModal            =    new Modal(document.getElementById('searchModal'), {keyboard: false, backdrop :false});
        this.linkAssetModal         =    new Modal(document.getElementById('linkAssetModal'), {keyboard: false, backdrop :false});
        this.assetBulkUploadModal   = new Modal(document.getElementById("assetBulkUploadModal"), { keyboard: false,backdrop: false });
         const changeSiteModalElement = document.getElementById('changeSiteModal');
            if (changeSiteModalElement) {
                changeSiteModalElement.addEventListener('hidden.bs.modal', () => {
                    this.setState({
                        changeSiteForm: {...this.changeSiteFormInit},
                        bulkChangeSiteForm: {...this.bulkChangeSiteFormInit},
                        isBulkSiteChange: false
                    });
                });
            }
            const changeStatusModalElement =
              document.getElementById("changeStatusModal");
            if (changeStatusModalElement) {
              changeStatusModalElement.addEventListener(
                "hidden.bs.modal",
                () => {
                  this.setState({
                    changeStatusForm: { ...this.changeStatusFormInit },
                    bulkChangeStatusForm: { ...this.bulkChangeStatusFormInit },
                    isBulkStatusChange: false,
                  });
                },
              );
            }
    }
    updateCriteriaHeight = () => {
        if (this.criteriaRef.current) {
            const height = this.criteriaRef.current.offsetHeight;
            if (this.state.criteriaHeight !== height) {
                this.setState({ criteriaHeight: height });
            }
        }
    };
    componentDidUpdate(prevProps, prevState) {
        if (prevState.formSearchedElems !== this.state.formSearchedElems) {
            setTimeout(() => {
                this.updateCriteriaHeight();
            }, 1000);
        }
    } 

    componentWillReceiveProps(nextProps){
        if(nextProps.iam_user_sites !== this.props.iam_user_sites) {
            this.initilaizeFilterFormData(nextProps);
        }
            
    }
    
    initilaizeFilterFormData        =       (pr)        =>      {

        this.setState({listing_loading: true}); 
        HttpAPICall.withAthorization('GET',  IAM_SUBASSEMBLY_URL + '/form_data', this.state.access_token ? this.state.access_token : pr.access_token, {}, {}, (resp) => {
            let formData = resp.data;
            this.setState({
                subAssemblyTags                  :   resp.data.tags && resp.data.tags.length > 0 ? resp.data.tags.map((tag) => { return {value: tag, label: tag}; }) : [],   
                subAssemblyCategories       :   formData && formData.sub_assembly_categories && formData.sub_assembly_categories.length > 0 ?  formData.sub_assembly_categories.map((c) => { return {value: c.id, label: c.name}; }) : [],      
                subAssemblyTags             :   formData && formData.sub_assembly_tags && formData.sub_assembly_tags.length > 0 ?  formData.sub_assembly_tags.map((tag) => { return {value: tag.name, label: tag.name}; }) : [],      
                allStatus                   :   formData && formData.sub_assembly_status && formData.sub_assembly_status.length > 0 ?  formData.sub_assembly_status.map((s) => { return {value: s.id, label: s.name}; }) : [],      
                // additionalAttributes        :   formData && formData.additional_attributes && formData.additional_attributes.length > 0 ?  formData.additional_attributes : [],      
                siteList                    :    pr.iam_user_sites ? pr.iam_user_sites.map((s) => { return {value: s.id, label:`${s.site_name} (${s.site_code})`,site_code : s.site_code}}) : [],
                linkingStatus                :   [{value : 'Y', label : 'Yes'}, {value: 'N', label : 'No'}],
            }, () => {
                if(this.props.match && this.props.match.params && this.props.match.params.id) {
                    this.viewSubAssembly(this.props.match.params.id, 'minimize');
                }
                if(pr && pr.location && pr.location.search && pr.location.search){
                    const paramObject =   new URLSearchParams(this.props.location.search);
                    this.setState({
                        subAssemblySearchForm : {
                            search_category_id : paramObject.getAll('search_category_id')[0] ? parseInt(paramObject.getAll('search_category_id')[0]) : '', 
                            search_site_ids : paramObject.getAll('search_site_id')[0] ? [parseInt(paramObject.getAll('search_site_id')[0])] : '',
                            search_linking_status : paramObject.getAll('linking_status')[0]? paramObject.getAll('linking_status')[0] : 0,
                            search_status_ids : paramObject.getAll('search_status_id')[0] ? [parseInt(paramObject.getAll('search_status_id')[0])] : []
                        }
                    }, () => {
                        this.searchFormSubmit();
                    })
                }else {
                    this.loadListingTblData(1);
                }
            });
        })
    }

    loadListingTblData                 =   (page = 1)  =>         {
        this.setState({listing_loading: true, listing_tbl_page: page});
        let params                      =   {page:page,...this.state.submittedSubAssemblySearchForm};
        HttpAPICall.withAthorization('GET',  IAM_SUBASSEMBLY_URL + '/list', this.state.access_token ? this.state.access_token : this.props.access_token, params, {}, (resp) => {
        
            let respData = resp.data;
            this.setState({
                sub_assembly_listing    :   respData.data,
                listingMeta             :   respData.meta,
                totalListingCount       :   respData.meta.total,
                selectedSubAssemblies   :   [],
                selectAll              :   false,
        });
        }).then(() => this.setState({listing_loading: false}));
    }
    assetBulkUploadFormSubmit = (event) => {
        event.preventDefault();
        this.setState({ assetBulkUploadFormSubmiting: true });
        const data = new FormData(document.getElementById("assetBulkUploadForm"));
        
          let headers = { 'Authorization': 'Bearer ' + this.props.access_token, };
        api.server2Api.post(IAM_API_BASE_URL_2 + "/sub_assembly/add_by_excel", data, { headers: headers })
            .then((response) => {
                toast.success(response.data.msg, {
                    position: toast.POSITION.TOP_RIGHT,
                });
                this.assetBulkUploadModal.hide();
                //Load Add Item Form Data :-

                DownloadFile.file(response.data.generated_file.file_path);
                setTimeout(() => {
                    this.loadListingTblData(1);
                }, 1000);
            })
            .catch((err) => {
                toast.error(
                    err?.response?.data?.message ?? "Unable to upload Asset Add File.",
                    { position: toast.POSITION.TOP_RIGHT }
                );
            })
            .then(() => {
                this.setState({ assetBulkUploadFormSubmiting: false });
            });
    };
     downloadHandler = () => {
        let params                      =   {...this.state.submittedSubAssemblySearchForm};
        HttpAPICall.withAthorization(
          "GET",
          IAM_API_BASE_URL_2 + "/sub_assembly/download",
          this.props.access_token, params,{},
          (response) => {
            DownloadFile.file(response.data.file_path);
            toast.success("File Downloaded Successfully", {
              position: toast.POSITION.TOP_RIGHT,
            });
          }
        );
      };
     downloadSampleFile = () => {
        HttpAPICall.withAthorization(
          "GET",
          IAM_API_BASE_URL_2 + "/sub_assembly/download_sample_excel",
          this.props.access_token,
          {},
          {},
          (response) => {
            DownloadFile.file(response.data.file_path);
            toast.success("File Downloaded Successfully", {
              position: toast.POSITION.TOP_RIGHT,
            });
            this.assetBulkUploadModal.hide();
          }
        );
      };
    deleteSubAssemblyhandler            =   ()  =>  {
        if(this.state.subAssemblyDetail.enc_id) {
            swal({
                title: "Delete Sub Assembly",
                text: "Are you sure you want to proceed?",
                icon: "warning",
                buttons: ["No", "Yes"],
            }).then(willDelete => {
                if (willDelete) {
                    const id        =   this.state.subAssemblyDetail.enc_id;
                    HttpAPICall.withAthorization('DELETE', IAM_SUBASSEMBLY_URL + '/delete/' + id, this.props.access_token, null, null, (response) => {
                        toast.success(response.data.msg, { position: toast.POSITION.TOP_RIGHT });
                        this.closeView();
                    });
                }
            })
        }
    }

    closeView           =       ()        =>      {
        this.setState({minimizeTable : false}, () => {
            // this.loadListingTblData(this.state.listing_tbl_page)
            this.props.history.push('/sub_assembly');
        });
    }


viewSubAssembly = (id, type = null) => {
        if (type === 'minimize') {
            this.setState({
                minimizeTable: true,
                subAssemblyId: id
            },() => {
                this.viewLoadData.current.subAssemblyDetail(id)
                this.viewLoadData.current.getDashboardDetail(id)
            })
        } else {
            this.setState({
                minimizeTable: true,
                subAssemblyId: id
            });
        }
    }



    viewSubAssemblyDetail   =   (subAssemblyDetail) => {
        this.setState({
            subAssemblyDetail   : subAssemblyDetail
        });
    }


    addSubAssemblyInit             =   () => {
        this.props.history.push('/sub_assembly_add');   
    }
    assetBulkUploadModalInit = () => {
        document.getElementById("addAssetFileSelector").value = null;

        this.assetBulkUploadModal.show();
    };
    handleSelectAll = (e) => {
        const checked = e.target.checked;
        if (checked) {
            const allIds = this.state.sub_assembly_listing.map(item => item.enc_id);
            this.setState({
                selectedSubAssemblies: allIds,
                selectAll: true
            });
        } else {
            this.setState({
                selectedSubAssemblies: [],
                selectAll: false
            });
        }
    };
    
    handleSelectSingle = (e, id) => {
        const checked = e.target.checked;
        let selected = [...this.state.selectedSubAssemblies];
        if (checked) {
            selected.push(id);
        } else {
            selected = selected.filter(item => item !== id);
        }
        this.setState({
            selectedSubAssemblies: selected,
            selectAll: selected.length === this.state.sub_assembly_listing.length
        });
    };
// Bulk Link/Delink Asset Modal Init
showBulkLinkAssetModalInit = (actionType = 'link') => {
    // Check if sub assemblies are selected
    if (this.state.selectedSubAssemblies.length === 0) {
        toast.error("Please select at least one Sub Assembly", {
            position: toast.POSITION.TOP_RIGHT,
        });
        return;
    }

    // Get selected items with full data
    const selectedItems = this.state.sub_assembly_listing.filter(
        item => this.state.selectedSubAssemblies.includes(item.enc_id)
    );

    if (selectedItems.length === 0) {
        toast.error("Selected Sub Assemblies not found", {
            position: toast.POSITION.TOP_RIGHT,
        });
        return;
    }

    // Check if all selected sub assemblies are from same site
    const uniqueSiteIds = [...new Set(selectedItems.map(item => item.site?.id).filter(id => id))];
    if (uniqueSiteIds.length > 1) {
        toast.error("You cannot select Sub Assemblies from different Sites. Please select from the same site.", {
            position: toast.POSITION.TOP_RIGHT,
        });
        return;
    }

    // Validate based on action type
    if (actionType === "link") {
        // Check if any selected sub assembly is already linked
        const alreadyLinked = selectedItems.filter((item) => item.asset_profile);
        if (alreadyLinked.length > 0) {
            toast.error(
                `${alreadyLinked.length} selected Sub Assembly(ies) are already linked with an Asset. Please select only unlinked sub assemblies for linking.`,
                { position: toast.POSITION.TOP_RIGHT }
            );
            return;
        }

        const siteId = selectedItems.length > 0 && selectedItems[0].site ? selectedItems[0].site.id : '';
        
        // Call LinkingModal's bulk method for linking
        this.linkAssetModalRef.current.linkBulkAssetModalInit(
            this.state.selectedSubAssemblies,
            this.state.sub_assembly_listing,
            'link',
            siteId
        );

    } else if (actionType === "delink") {
        // Check if any selected sub assembly is NOT linked
        const notLinked = selectedItems.filter((item) => !item.asset_profile);
        if (notLinked.length > 0) {
            toast.error(
                `${notLinked.length} selected Sub Assembly(ies) are not linked with any Asset. Please select only linked sub assemblies for delinking.`,
                { position: toast.POSITION.TOP_RIGHT }
            );
            return;
        }

        // Check if all selected sub assemblies are linked with same asset
        const assetIds = [...new Set(selectedItems.map((i) => i.asset_profile?.asset_id).filter(id => id))];
        if (assetIds.length > 1) {
            toast.error(
                "Selected Sub Assemblies are linked with different Assets. Please select sub assemblies linked with the same asset.",
                { position: toast.POSITION.TOP_RIGHT }
            );
            return;
        }

        // Call LinkingModal's bulk method for delinking
        this.linkAssetModalRef.current.linkBulkAssetModalInit(
            this.state.selectedSubAssemblies,
            this.state.sub_assembly_listing,
            'delink',
            ''
        );
    }
};
    //***********************Sub Assembly JSX****************
    subAssemblyListjsx          =   ()  =>  {
        return (<Ax><div className="page_title row m0">
            <div className={this.state.minimizeTable ? "col-3" : "col-12"}>
                <h3>Sub Assembly </h3>
                {!this.state.minimizeTable
                    ? <div className="text-end mt15">
                        <button type="button" 
                        disabled={this.state.listing_loading || this.state.file_downloading || !this.props.permissions.includes('iam-sub-assembly-add')} className="btn btn-primary" onClick={this.addSubAssemblyInit}>
                            Add Sub Assembly
                        </button>
                        <span className="dropdown">
                            <button
                                type="button"
                                id="actionMenuButton"
                                data-bs-toggle="dropdown"
                                aria-expanded="false"
                                className="btn btn-secondary"
                            >
                                <tapIcon.imageIcon
                                    icon={tapIcon.ActionIcon}
                                    className="img-fluid"
                                    alt="item-action"
                                />
                            </button>
                            <ul
                                className="dropdown-menu"
                                aria-labelledby="dropdownMenuButton1"
                            >
                                <li>
                                    <Link
                                        className="dropdown-item"
                                        onClick={this.assetBulkUploadModalInit}
                                        role="button"
                                    >
                                        Bulk Upload
                                    </Link>
                                </li>
                                 <li>
                                    <Link
                                        className="dropdown-item"
                                        onClick={this.downloadHandler}
                                        role="button"
                                    >
                                        Download
                                    </Link>
                                </li>
                                {this.props.permissions.includes('iam-sub-assembly-edit') && (
                                    <li>
                                        <Link
                                            className="dropdown-item"
                                            onClick={() => this.showSiteChangeModalInit(true)}
                                            role="button"
                                        >
                                            Bulk Site Change
                                        </Link>
                                    </li>
                                )}
                                {this.props.permissions.includes('iam-sub-assembly-change-status') && (
                                    <li>
                                        <Link
                                            className="dropdown-item"
                                            onClick={() => this.showStatusChangeModalInit(true)}
                                            role="button"
                                        >
                                            Bulk Status Change
                                        </Link>
                                    </li>
                                )}
                           {this.props.permissions.includes('iam-sub-assembly-asset-manage') && (
                                <li>
                                    <Link
                                        className="dropdown-item"
                                        onClick={() => this.showBulkLinkAssetModalInit('link')}
                                        role="button"
                                    >
                                        Bulk Link Asset
                                    </Link>
                                </li>
                            )}
                            {/* NEW: Bulk Delink Asset Option */}
                            {this.props.permissions.includes('iam-sub-assembly-asset-manage') && (
                                <li>
                                    <Link
                                        className="dropdown-item"
                                        onClick={() => this.showBulkLinkAssetModalInit('delink')}
                                        role="button"
                                    >
                                        Bulk Delink Asset
                                    </Link>
                                </li>
                            )}
                        </ul>
                    </span>
                        <button type="button" disabled={this.state.listing_loading || this.state.file_downloading} onClick={this.searchModalInit} className="btn btn-secondary" >
                            <tapIcon.imageIcon icon={tapIcon.SearchIcon} className="img-fluid" alt="item-action" />
                        </button>
                        {
                        //     <span className="dropdown">
                        //     <button type="button" id='actionMenuButton' data-bs-toggle="dropdown" aria-expanded="false" className="btn btn-secondary" disabled={this.state.excelDownloading == true}>
                        //         <tapIcon.imageIcon icon={tapIcon.ActionIcon} className="img-fluid" alt="item-action" />
                        //     </button>
                        //     <ul className="dropdown-menu" aria-labelledby="dropdownMenuButton1">
                        //         <li><a className="dropdown-item"  role="button" >Download</a></li>
                        //     </ul>

                        // </span>
                    }
                    </div>
                    : null}
            </div>
            {
                this.state.minimizeTable
                    ? (
                        <div className="col-9 tap_border_left">
                            <h3 className="text-capitalize">Sub Assembly : {this.state.subAssemblyDetail && this.state.subAssemblyDetail.name + " (" + this.state.subAssemblyDetail.card_number + ")" }</h3>
                            <div className="text-end mt15">
                                <span className="dropdown">
                                    <button type="button" id='actionMenuButton' data-bs-toggle="dropdown" aria-expanded="false" className="btn btn-secondary"
                                    disabled={ this.state.subAssemblyDetail ? false : true}
                                    >
                                        <tapIcon.imageIcon icon={tapIcon.ActionIcon} className="img-fluid" alt="item-action" />
                                    </button>
                                    <ul className="dropdown-menu" aria-labelledby="dropdownMenuButton1">
                                       {this.props.permissions.includes('iam-sub-assembly-edit') && <li> 
                                            <Link role="button" className={['dropdown-item'].join(' ')} 
                                            to= {{
                                                pathname : '/sub_assembly_update', 
                                                state : {subAssemblyDetail : this.state.subAssemblyDetail, isClone : false}
                                            }}
                                            style={{ "pointerEvents": "all" }}
                                            >
                                                Edit 
                                            </Link>
                                        </li>}
                                        {this.state.subAssemblyDetail && this.state.subAssemblyDetail.status?.id !== 2 && this.props.permissions.includes('iam-sub-assembly-edit') &&  <li>
                                            <Link role="button" className={['dropdown-item'].join(' ')} style={{ "pointerEvents": "all" }}   onClick={() => this.showSiteChangeModalInit(false)}>
                                                Change Linked Site
                                            </Link>
                                        </li>}
                                        {this.props.permissions.includes('iam-sub-assembly-change-status') && <li>
                                            <Link role="button" className={['dropdown-item'].join(' ')} style={{ "pointerEvents": "all" }} onClick={()=>this.showStatusChangeModalInit(false)}>
                                                Change Status
                                            </Link>
                                        </li>} 
                                       {this.state.subAssemblyDetail && !this.state.subAssemblyDetail.asset_profile && this.state.subAssemblyDetail.status?.id !== 2 && this.props.permissions.includes('iam-sub-assembly-asset-manage') && <li>
                                            <Link role="button" className={['dropdown-item'].join(' ')} style={{ "pointerEvents": "all" }} onClick={() => this.linkAssetModalInit('link')}>
                                                Link Asset
                                            </Link>
                                        </li>}
                                        {this.state.subAssemblyDetail && this.state.subAssemblyDetail.asset_profile && this.state.subAssemblyDetail.status?.id !== 2 && this.props.permissions.includes('iam-sub-assembly-asset-manage') &&  <li>
                                            <Link role="button" className={['dropdown-item'].join(' ')} style={{ "pointerEvents": "all" }} onClick={() => this.linkAssetModalInit('delink')}>
                                                DeLink Asset
                                            </Link>
                                        </li>}
                                        {this.props.permissions.includes('iam-sub-assembly-add') && <li> 
                                            <Link role="button" className={['dropdown-item'].join(' ')} 
                                            to= {{
                                                pathname : '/sub_assembly_add', 
                                                state : {subAssemblyDetail : this.state.subAssemblyDetail, isClone : true}
                                            }}
                                            style={{ "pointerEvents": "all" }}>
                                                Clone 
                                            </Link>
                                        </li>}

                                        {this.props.permissions.includes('iam-sub-assembly-edit') && <li> 
                                            <Link role="button" className={['dropdown-item'].join(' ')} style={{ "pointerEvents": "all" }} onClick={this.deleteSubAssemblyhandler}>Delete</Link>
                                        </li>}

                                    </ul>
                                </span>
                                <button onClick={this.closeView} type="button" className="btn btn-secondary">
                                    <tapIcon.imageIcon icon={tapIcon.CloseIcon} className="img-fluid" alt="item-close" />
                                </button>
                            </div>
                        </div>
                    )
                    : null
            }
        </div>
            <div className="container-fluid pl5">
                <div className="page_containt row">
                    <div className={['pageTbl', this.state.minimizeTable ? 'col-3' : 'col-12'].join(' ')} >
                        {this.subAssemblyListingTableJsx()}
                    </div>
                    {this.state.minimizeTable && <div className="col-9 pr4 pl4">
                        <SubAssemblyDetail ref={this.viewLoadData} closeView={this.closeView} viewSubAssemblyDetail = {this.viewSubAssemblyDetail} subAssemblyId = {this.state.subAssemblyId}/>
                    </div>}
                </div>
            </div>
        </Ax>);
    }
    assetBulkUploadModalJsx = () => {
        return (
            <div className="modal fade" id="assetBulkUploadModal" tabIndex="-1">
                <div className="modal-dialog">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title" id="itemBulkUploadModalLabel">
                                Bulk Add Asset
                            </h5>
                            <button
                                type="button"
                                disabled={this.state.assetBulkUploadFormSubmiting}
                                className="btn-close"
                                data-bs-dismiss="modal"
                                aria-label="Close"
                            ></button>
                        </div>
                        <form
                            onSubmit={this.assetBulkUploadFormSubmit}
                            id="assetBulkUploadForm"
                            method="post"
                            encType="multipart/form-data"
                        >
                            <div className="modal-body">
                                <div className="row align-items-center mb-3 mt-3">
                                    <div className="col-12">
                                        <input
                                            name="document"
                                            id="addAssetFileSelector"
                                            type="file"
                                            className="form-control"
                                            required={true}
                                        />
                                    </div>
                                    <div className="col-12 mt-2 form-text">
                                        # Excel Sheet with Extention xls,xlm,xlsx,ods Allowed
                                    </div>
                                    <div className="col-12 mt-2 form-text">
                                        # Miximum 100 MB Size of Excel Sheet Allowed
                                    </div>
                                </div>
                            </div>
                            <div className="modal-footer d-flex justify-content-between">
                                <div>
                                    <a
                                        type="button"
                                        className="float-left"
                                        href="#"
                                        onClick={this.downloadSampleFile}
                                    >
                                        Download Sample File
                                    </a>
                                </div>
                                <div>
                                    <button
                                        type="button"
                                        disabled={this.state.assetBulkUploadFormSubmiting}
                                        className="btn btn-secondary mx-2"
                                        data-bs-dismiss="modal"
                                    >
                                        Close
                                    </button>
                                    <button
                                        type="submit"
                                        disabled={this.state.assetBulkUploadFormSubmiting}
                                        className="btn btn-primary"
                                    >
                                        Submit{" "}
                                        {this.state.assetBulkUploadFormSubmiting ? (
                                            <tapIcon.FontAwesomeIcon
                                                icon={tapIcon.faSyncAlt}
                                                className="fa-spin"
                                            />
                                        ) : (
                                            ""
                                        )}
                                    </button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        );
    };
    subAssemblyListingTableJsx  =   ()  =>  {
        return (<Ax>
            <div ref={this.criteriaRef}
                style={{
                    position: 'sticky',
                    top: 0,
                    background: 'white',
                }}>
             <DisplaySearchCriteria searchedElems={this.state.formSearchedElems} onClearFilter={this.searchFormClear} />
             </div>
            <table className="table table-bordered bg-white table-sm">
                <thead className="table-secondary"style={{top: `${this.state.criteriaHeight}px`,
                    position: 'sticky',
                }} >
                    {this.state.minimizeTable
                        ? (<tr>
                            <th scope="col" style={{ width: "15%" }}>Sub Assembly</th>
                        </tr>)
                        : (<tr>
                              <th scope="col" style={{ width: "3%" }} className="text-center">
                                <input
                                    type="checkbox"
                                    checked={this.state.selectAll}
                                    onChange={this.handleSelectAll}
                                    disabled={this.state.sub_assembly_listing.length === 0}
                                />
                            </th>
                            <th scope="col" style={{ width: "5%" }} className="text-center">S.No</th>
                            <th scope="col" style={{ width: "18%" }}>Sub-Assembly</th>
                            <th scope="col" style={{ width: "15%" }}>Category</th>
                            <th scope="col" style={{ width: "17%" }}>Tags</th>
                            <th scope="col" style={{ width: "16%" }}>Site</th>
                            <th scope="col" style={{ width: "17%" }}>Linked Asset</th>
                            <th scope="col" style={{ width: "9%" }}>Status</th>
                        </tr>)
                    }
                </thead>
                <tbody>
                    {this.state.listing_loading
                        ? (<tr><td colSpan="9"><Loader /></td></tr>)
                        : (this.state.sub_assembly_listing.length > 0
                            ? (this.state.sub_assembly_listing.map((data, index) => {
                                return (<tr key={index} >
                                    {
                                        data.is_Loading && data.is_Loading == true ? <td colSpan={10} className="text-center"><Loader /></td> 
                                         :
                                        this.state.minimizeTable
                                            ? (
                                                <Ax>
                                                    <td style={{ width: "25%" }}>
                                                        <div className="text-capitalize link-primary cursor_pointer"><Link to={'/sub_assembly/' + data.enc_id} onClick={() => this.viewSubAssembly(data.enc_id, 'minimize')}>{data.name ? data.name : "-"}</Link></div>
                                                        <div className="mt-1">
                                                            <small className="text-capitalize ">{data.card_number ? data.card_number : "-"} </small>
                                                            <small className="float-end">
                                                            <Status color={data.status && data.status.color_code}>{data.status && data.status.name}</Status></small>
                                                        </div>
                                                    </td>
                                                </Ax>
                                            )
                                            : (<Ax>
                                                 <td className="text-center">
                                                    <input
                                                        type="checkbox"
                                                        checked={this.state.selectedSubAssemblies.includes(data.enc_id)}
                                                        onChange={(e) => this.handleSelectSingle(e, data.enc_id)}
                                                    />
                                                </td>
                                                <td className="text-center"> {index+1}</td>
                                                <td>
                                                    <Link to={'/sub_assembly/' + data.enc_id} onClick={() => this.viewSubAssembly(data.enc_id, 'minimize')}>
                                                        {data.name ? data.name : "-"}
                                                    </Link>
                                                    <br/>
                                                    <span className='text-sm form-text'>Code : ({data.card_number ? data.card_number : "-"})</span>
                                                </td>
                                                <td>{data.category ? data.category.name : "-"}</td>
                                                 <td>
                                                    {data.sub_assembly_tags && data.sub_assembly_tags.length > 0 ? data.sub_assembly_tags.map(i => { return (i) }).join(', ') : "-"}
                                                    </td>
                                                <td>{data.site ? data.site.site_name : "-"}</td>
                                                <td>
                                                    {data.asset_profile ? <div>{data.asset_profile.name} 
                                                    <br/><span className='form-text'>(Code : {data.asset_profile.asset_code})</span></div> : "-"}
                                                    {data.asset_date_change && <><span className='form-sm text-sm'>Date of Linking : {DateService.dateTimeFormat(data.asset_date_change)}</span></>}
                                                </td> 
                                                <td><Status color={data.status ? data.status.color_code : ''}>{data.status ? data.status.name : '-'}</Status></td>
                                            </Ax>
                                            )}
                                </tr>)
                            }))
                            : (<tr><td colSpan="10" className="text-center">No Records</td></tr>)
                        )
                    }

                </tbody>
            </table>
            <DisplayListPagination
                meta={this.state.listingMeta}
                onPageChange={(e) => this.loadListingTblData(e.selected + 1)}
            />
        </Ax>)
    }

    searchFormSubmit    =   (event= null)  =>  {
        event && event.preventDefault();
        //Get All Keys :-
        let serachFormKeys              =   Object.keys(this.state.subAssemblySearchForm);
        let searchedElems               =   [];
        let subAssemblySearchParams     =   {};
        serachFormKeys.map((key)        =>  {
            let label                       =   this.subAssemblySearchFormLabel[key];
            let value                       =   this.state.subAssemblySearchForm[key];
            if(value && value.toString().length > 0) {
                subAssemblySearchParams[key]      =   value;
                if(label) {
                    let show_val            =   value;
                    if(key == 'search_name') {
                        show_val            =   this.state.subAssemblySearchForm.search_name;
                    }
                    if(key == 'search_serial_number') {
                        show_val            =   this.state.subAssemblySearchForm.search_serial_number;
                    }
                    if(key == 'search_card_number') {
                        show_val            =   this.state.subAssemblySearchForm.search_card_number;
                    }
                    if(key == 'search_category_id') {
                        show_val            =   this.state.subAssemblyCategories.filter((c) => c.value == value).map(c => c.label).join(', ');
                    }
                    if(key == 'search_linking_status') {
                        show_val            =   this.state.linkingStatus.filter((l) => l.value == value).map(l => l.label).join(', ');
                    }
                    if(key == 'search_site_ids') {
                        show_val            =   this.state.siteList.filter((s) => value.includes(s.value)).map(s => s.label).join(', ');
                    }                    
                    if(key == 'search_asset_ids') {
                        show_val            =   this.state.searchedAssets.filter((a) => value.includes(a.value)).map(a => a.label).join(', ');
                    }                    
                    if(key == 'search_status_ids') {
                        show_val            =   this.state.allStatus.filter((a) => value.includes(a.value)).map(a => a.label).join(', ');
                    }   
                     if(key == 'search_tags') {
                        show_val            =   this.state.subAssemblyTags.filter(s => this.state.subAssemblySearchForm.search_tags && this.state.subAssemblySearchForm.search_tags.includes(s.value)).map(s => s.value).join(', ');
                    }                 
                    searchedElems.push(label + `<b>${show_val}</b>`);
                }
            }
        });
        //Generate Html :-
        this.setState({
            submittedSubAssemblySearchForm  :   {...this.state.subAssemblySearchForm},
            formSearchedElems               :   searchedElems
        }, () => {
            this.searchModal.hide();
            this.loadListingTblData(1)
        });
    }

        
    searchModalInit  = () => {
        this.searchModal.show();
    }

    searchFormClear     =   ()  =>  {
        this.setState({
            subAssemblySearchForm           :   {...this.subAssemblySearchInitState},
            submittedSubAssemblySearchForm  :   {...this.subAssemblySearchInitState},
            formSearchedElems               :   []
        }, () => {
            this.searchModal.hide();
            this.loadListingTblData(1)
             this.setState({
                criteriaHeight: 0
            })
        });
    }


    subAssemblySearchModalJsx   =   ()  =>  {
        return (
            <div className="modal fade" id="searchModal" tabIndex="-1">
                <div className="modal-dialog modal-lg">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title" id="searchModalLabel">Sub Assembly Search</h5>
                            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                        </div>
                        <form onSubmit={this.searchFormSubmit} id="searchForm">
                            <div className="modal-body">
                                <div className="row mb-3">
                                    <label className="col-sm-2 col-form-label col-form-label-sm">Name</label>
                                    <div className="col-sm-4">
                                        <input
                                            type="text"
                                            name="search_name"
                                            className="form-control form-control-sm"
                                            placeholder="Enter Sub Assembly Name"
                                            autoComplete="off"
                                            value={this.state.subAssemblySearchForm.search_name}
                                            onChange={(e) => this.formInputHandler(e, "subAssemblySearchForm")}
                                        />
                                    </div>
                                    <label className="col-sm-2 col-form-label col-form-label-sm">Code</label>
                                    <div className="col-sm-4">
                                        <input
                                            type="text"
                                            name="search_card_number"
                                            className="form-control form-control-sm"
                                            placeholder="Enter Sub Assembly Code"
                                            autoComplete="off"
                                            value={this.state.subAssemblySearchForm.search_card_number}
                                            onChange={(e) => this.formInputHandler(e, "subAssemblySearchForm")}
                                        />
                                    </div>
                                </div>
                                <div className="row mb-3">
                                    <label className="col-sm-2 col-form-label col-form-label-sm">Status</label>
                                    <div className="col-sm-4">
                                        <TapSelect
                                            options={this.state.allStatus}
                                            changeEvent={(selectedOption) => {
                                                this.tapSelectChange(selectedOption, 'subAssemblySearchForm', 'search_status_ids');
                                            }}
                                            isSearchable={true}
                                            isClearable={true}
                                            menuPlacement="bottom"
                                            value={this.state.allStatus.filter(s => this.state.subAssemblySearchForm?.search_status_ids?.includes(s.value))}
                                            placeholder="Select Status"
                                            containerHeight="30px"
                                            fontSize="93%"
                                            isMulti={true}
                                        />
                                    </div>
                                    <label className="col-sm-2 col-form-label col-form-label-sm">Serial Number</label>
                                    <div className="col-sm-4">
                                        <input
                                            type="text"
                                            name="search_serial_number"
                                            className="form-control form-control-sm"
                                            placeholder="Enter Serial Number"
                                            autoComplete="off"
                                            value={this.state.subAssemblySearchForm.search_serial_number}
                                            onChange={(e) => this.formInputHandler(e, "subAssemblySearchForm")}
                                        />
                                    </div>
                                </div>
                                <div className="row mb-3">
                                    <label className="col-sm-2 col-form-label col-form-label-sm">Category</label>
                                    <div className="col-sm-4">
                                        <TapSelect
                                            options={this.state.subAssemblyCategories}
                                            changeEvent={(selectedOption) => {
                                                this.tapSelectChange(selectedOption, 'subAssemblySearchForm', 'search_category_id');
                                            }}
                                            isSearchable={true}
                                            isClearable={true}
                                            menuPlacement="bottom"
                                            value={this.state.subAssemblyCategories.find(c => c.value == this.state.subAssemblySearchForm.search_category_id)}
                                            placeholder="Select Category"
                                            containerHeight="30px"
                                            fontSize="93%"
                                        />
                                    </div>
                                    <label className="col-sm-2 col-form-label col-form-label-sm">Linked Status</label>
                                    <div className="col-sm-4">
                                        <TapSelect
                                            options={this.state.linkingStatus}
                                            changeEvent={(selectedOption) => {
                                                this.tapSelectChange(selectedOption, 'subAssemblySearchForm', 'search_linking_status');
                                            }}
                                            isSearchable={true}
                                            isClearable={true}
                                            menuPlacement="bottom"
                                            value={this.state.linkingStatus.find(l => l.value == this.state.subAssemblySearchForm.search_linking_status)}
                                            placeholder="Select Linked Status"
                                            containerHeight="30px"
                                            fontSize="93%"
                                        />
                                    </div>
                                </div>
                                <div className="row mb-3">
                                    <label className="col-sm-2 col-form-label col-form-label-sm">Site</label>
                                    <div className="col-sm-4">
                                        <TapSelect
                                            options={this.state.siteList}
                                            changeEvent={(selectedOption) => {
                                                this.tapSelectChange(selectedOption, 'subAssemblySearchForm', 'search_site_ids');
                                            }}
                                            isSearchable={true}
                                            isClearable={true}
                                            menuPlacement="bottom"
                                            value={this.state.siteList.filter(s => this.state.subAssemblySearchForm?.search_site_ids?.includes(s.value))}
                                            placeholder="Select Sites"
                                            containerHeight="30px"
                                            fontSize="93%"
                                            isMulti={true}
                                        />
                                    </div>
                                    <label className="col-sm-2 col-form-label col-form-label-sm">Tags</label>
                                    <div className="col-sm-4 ">
                                        <TapSelect
                                            isSearchable={true}
                                            isClearable={true}
                                            placeholder="Select Tags"
                                            containerHeight="30px"
                                            fontSize="93%"
                                            isMulti={true}
                                            options={this.state.subAssemblyTags}
                                            value={this.state.subAssemblyTags.filter(s => this.state.subAssemblySearchForm.search_tags && this.state.subAssemblySearchForm.search_tags.includes(s.value))}
                                            changeEvent={(selectedOption) => this.tapSelectChange(selectedOption, 'subAssemblySearchForm', 'search_tags')}
                                        />
                                    </div>
                                </div>
                                <div className="row mb-3">
                                    <label className="col-sm-2 col-form-label col-form-label-sm">Assets</label>
                                    <div className="col-sm-10">
                                        <InputAssetSearch
                                            containerHeight="30px"
                                            fontSize="93%"
                                            changeEvent={(selectedOption) => {
                                                this.tapSelectChange(selectedOption, 'subAssemblySearchForm', 'search_asset_ids');
                                                this.setState({ searchedAssets: selectedOption && selectedOption.length > 0 ? selectedOption : [] });
                                            }}
                                            isMulti={true}
                                            menuPlacement="top"
                                            value={this.state.searchedAssets.length > 0 ? this.state.searchedAssets.map(a => { a.label = a.display_label; return a; }) : []}
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className="modal-footer">
                                <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">Close</button>
                                <button type="submit" className="btn btn-primary">Search</button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        );
    }

    showStatusChangeModalInit = (isBulk = false) => {
        if (isBulk) {
          // Check if sub assemblies are selected for bulk
          if (this.state.selectedSubAssemblies.length === 0) {
            toast.error("Please select at least one Sub Assembly", {
              position: toast.POSITION.TOP_RIGHT,
            });
            return;
          }
          const selectedItems = this.state.sub_assembly_listing.filter((item) =>
            this.state.selectedSubAssemblies.includes(item.enc_id),
          );

          const firstStatusId = selectedItems[0]?.status?.id;

          const allSameStatus = selectedItems.every(
            (item) => item.status?.id === firstStatusId,
          );

          if (!allSameStatus) {
            toast.error(
              "Please select Sub Assemblies with the same status for bulk status change",
              {
                position: toast.POSITION.TOP_RIGHT,
              },
            );
            return;
          }

          this.setState(
            {
              bulkChangeStatusForm: { ...this.bulkChangeStatusFormInit },
              isBulkStatusChange: true,
            },
            () => {
              this.changeStatusModal.show();
            },
          );
        } else {
            this.setState({
                changeStatusForm: {...this.changeStatusFormInit},
                isBulkStatusChange: false
            }, () => {
                this.changeStatusModal.show();
            });
        }
    }
    

    submitChangeStatusForm = (e) => {
    e.preventDefault();
    
    const isBulk = this.state.isBulkStatusChange;
    
    if (isBulk) {
        // Bulk status change
        if (this.state.selectedSubAssemblies.length === 0) {
            toast.error("No sub assemblies selected", {
                position: toast.POSITION.TOP_RIGHT,
            });
            return;
        }
        
        this.setState({ saveFormSubmitting: true });
        
        const data = {
            ids: this.state.selectedSubAssemblies,
            status_id: this.state.bulkChangeStatusForm.status_id,
            status_since_date: this.state.bulkChangeStatusForm.status_since_date,
            remark: this.state.bulkChangeStatusForm.remark
        };
        
        HttpAPICall.withAthorization(
            'PUT', 
            IAM_API_BASE_URL_2 + '/multiple_sub_assembly/status_change', 
            this.props.access_token, 
            null, 
            data, 
            (response) => {
                toast.success(response.data.msg || "Status changed successfully for selected sub assemblies", { 
                    position: toast.POSITION.TOP_RIGHT 
                });
                
                this.setState({
                    bulkChangeStatusForm: {...this.bulkChangeStatusFormInit},
                    selectedSubAssemblies: [],
                    selectAll: false,
                    isBulkStatusChange: false
                });
                
                this.changeStatusModal.hide();
                this.loadListingTblData(this.state.listing_tbl_page);
            }
        ).then(() => this.setState({ saveFormSubmitting: false }));
        
    } else {
        // Single status change (existing code)
        if (this.state.subAssemblyDetail && this.state.subAssemblyDetail.enc_id) {
            this.setState({ saveFormSubmitting: true });
            const id = this.state.subAssemblyDetail.enc_id;
            const data = {...this.state.changeStatusForm};
            
            HttpAPICall.withAthorization(
                'PUT', 
                IAM_SUBASSEMBLY_URL + '/status_change/' + id, 
                this.props.access_token, 
                null, 
                data, 
                (response) => {
                    toast.success(response.data.msg, { position: toast.POSITION.TOP_RIGHT });
                    
                    this.setState({
                        changeStatusForm: {...this.changeStatusFormInit},
                        isBulkStatusChange: false
                    });
                    
                    this.viewSubAssembly(id, 'minimize');
                    this.loadListingTblData();
                    this.changeStatusModal.hide();
                }
            ).then(() => this.setState({ saveFormSubmitting: false }));
        }
    }
}
    renderSubAssemblyNamesForStatus = () => {
        if (this.state.selectedSubAssemblies.length === 0) return "-";
        const selectedItems = this.state.sub_assembly_listing.filter(
            item => this.state.selectedSubAssemblies.includes(item.enc_id)
        );

        if (selectedItems.length === 0) return "-";

        const firstTwoNames = selectedItems.slice(0, 2).map(item =>
            item.name || item.card_number || 'Unknown'
        ).join(', ');

        const remainingCount = selectedItems.length - 2;

        if (remainingCount > 0) {
            return `${firstTwoNames} +${remainingCount} more`;
        }

        return firstTwoNames;
    };
    statusChangeModalJsx = () => {
    const isBulk = this.state.isBulkStatusChange;
    const formData = isBulk ? this.state.bulkChangeStatusForm : this.state.changeStatusForm;
    const selectedCount = this.state.selectedSubAssemblies?.length;
    const subAssemblyName = this.state.subAssemblyDetail ? this.state.subAssemblyDetail.name : '';
    const currentStatus = this.state.subAssemblyDetail && this.state.subAssemblyDetail.status ? 
                         this.state.subAssemblyDetail.status.name : '';
    const currentStatusDate = this.state.subAssemblyDetail && this.state.subAssemblyDetail.status_since_date ? 
                             DateService.dateTimeFormat(this.state.subAssemblyDetail.status_since_date, 'DD-MMM-YYYY') : '';
    
    return (
        <div className="modal fade" id="changeStatusModal" tabIndex="-1">
            <div className="modal-dialog modal-lg">
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title" id="changeStatusModalLabel">
                            {isBulk ? 'Bulk Status Change for Sub Assemblies' : 'Change Status'}
                        </h5>
                        <button 
                            type="button" 
                            className="btn-close" 
                            data-bs-dismiss="modal" 
                            aria-label="Close"
                            onClick={() => {
                                this.setState({
                                    changeStatusForm: {...this.changeStatusFormInit},
                                    bulkChangeStatusForm: {...this.bulkChangeStatusFormInit},
                                    isBulkStatusChange: false
                                });
                            }}
                        ></button>
                    </div>
                    <form onSubmit={this.submitChangeStatusForm}>
                        <div className="modal-body">
                            {isBulk ? (
                                <>
                                    <div className="row mb-3">
                                        <label className="col-sm-3 col-form-label col-form-label-sm">
                                            Selected Sub Assemblies
                                        </label>
                                        <div className="col-sm-9">
                                            <input
                                                type="text"
                                                className="form-control form-control-sm"
                                                disabled={true}
                                                value={this.renderSubAssemblyNamesForStatus()}
                                            />
                                        </div>
                                    </div>
                                </>
                            ) : (
                                // Single Status Change Fields
                                <>
                                    <div className="row mb-3">
                                        <label className="col-sm-3 col-form-label col-form-label-sm">Sub Assembly</label>
                                        <div className="col-sm-9">
                                            <input
                                                type="text"
                                                name="name"
                                                className="form-control form-control-sm"
                                                placeholder="Sub Assembly"
                                                autoComplete="off"
                                                disabled={true}
                                                value={subAssemblyName}
                                            />
                                        </div>
                                    </div>
                                    <div className="row mb-3">
                                        <label className="col-sm-3 col-form-label col-form-label-sm">Current Status</label>
                                        <div className="col-sm-9">
                                            <input
                                                type="text"
                                                name="status"
                                                className="form-control form-control-sm"
                                                placeholder="Current Status"
                                                autoComplete="off"
                                                disabled={true}
                                                value={currentStatus}
                                            />
                                        </div>
                                    </div>
                                    <div className="row mb-3">
                                        <label className="col-sm-3 col-form-label col-form-label-sm">Status Since Date</label>
                                        <div className="col-sm-9">
                                            <input
                                                type="text"
                                                name="current_status_since_date"
                                                className="form-control form-control-sm"
                                                placeholder="Status Since Date"
                                                autoComplete="off"
                                                disabled={true}
                                                value={currentStatusDate}
                                            />
                                        </div>
                                    </div>
                                </>
                            )}
                            
                            {/* Common Fields for both */}
                            <div className="row mb-3">
                                <label className="col-sm-3 col-form-label col-form-label-sm require">Status</label>
                                <div className="col-sm-9">
                                    <TapSelect
                                        options={this.state.allStatus}
                                        changeEvent={(selectedOption) => {
                                            const formName = isBulk ? 'bulkChangeStatusForm' : 'changeStatusForm';
                                            this.tapSelectChange(selectedOption, formName, 'status_id');
                                        }}
                                        isSearchable={true}
                                        isClearable={true}
                                        menuPlacement="bottom"
                                        placeholder="Select Status"
                                        containerHeight="30px"
                                        fontSize="93%"
                                        required={true}
                                        value={this.state.allStatus.find(s => formData.status_id === s.value)}
                                    />
                                </div>
                            </div>
                            
                            <div className="row mb-3">
                                <label className="col-sm-3 col-form-label col-form-label-sm require">Status Date</label>
                                <div className="col-sm-9">
                                    <DatePicker
                                        selected={
                                            formData.status_since_date
                                                ? moment(formData.status_since_date).toDate()
                                                : false
                                        }
                                        name="status_since_date"
                                        onChange={(value) => {
                                            const formName = isBulk ? 'bulkChangeStatusForm' : 'changeStatusForm';
                                            this.formDateHandler('status_since_date', value, formName, 'YYYY-MM-DD HH:mm:ss');
                                        }}
                                        dateFormat="dd-MMM-yyyy hh:mm a"
                                        className={"form-control form-control-sm"}
                                        showMonthDropdown
                                        showYearDropdown
                                        showTimeSelect
                                        timeIntervals={5}
                                        timeCaption="Time"
                                        autoComplete="off"
                                        scrollMonthYearDropdown
                                        required={true}
                                        maxDate={new Date()}
                                        placeholderText="Please Enter Status Date"
                                    />
                                </div>
                            </div>
                            
                            <div className="row mb-3">
                                <label className="col-sm-3 col-form-label col-form-label-sm require">Remark</label>
                                <div className="col-sm-9">
                                    <textarea
                                        name="remark"
                                        onChange={(e) => {
                                            const formName = isBulk ? 'bulkChangeStatusForm' : 'changeStatusForm';
                                            this.formInputHandler(e, formName);
                                        }}
                                        className="form-control"
                                        placeholder="Please Add Remark"
                                        required
                                        style={{ height: "100px" }}
                                        value={formData.remark}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="modal-footer">
                            <button 
                                type="button" 
                                disabled={this.state.saveFormSubmitting} 
                                className="btn btn-secondary" 
                                data-bs-dismiss="modal"
                                onClick={() => {
                                    this.setState({
                                        changeStatusForm: {...this.changeStatusFormInit},
                                        bulkChangeStatusForm: {...this.bulkChangeStatusFormInit},
                                        isBulkStatusChange: false
                                    });
                                }}
                            >
                                Close
                            </button>
                            <button 
                                type="submit" 
                                disabled={this.state.saveFormSubmitting} 
                                className="btn btn-primary mx-2"
                            >
                                {isBulk ? 'Update All' : 'Save'} 
                                {this.state.saveFormSubmitting ? (
                                    <TapIcon.FontAwesomeIcon icon={TapIcon.faSyncAlt} className="fa-spin" />
                                ) : ''}
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
}
    showSiteChangeModalInit = (isBulk = false) => {
    if (isBulk) {
        // Check if sub assemblies are selected for bulk
        if (this.state.selectedSubAssemblies.length === 0) {
            toast.error("Please select at least one Sub Assembly", {
                position: toast.POSITION.TOP_RIGHT,
            });
            return;
        }
        
        this.setState({
            bulkChangeSiteForm: {...this.bulkChangeSiteFormInit},
            isBulkSiteChange: true
        });
    } else {
        this.setState({
            changeSiteForm: {...this.changeSiteFormInit},
            isBulkSiteChange: false
        });
    }
    
    this.changeSiteModal.show();
}
   submitChangeSiteForm = (e) => {
    e.preventDefault();
    
    const isBulk = this.state.isBulkSiteChange;
    
    if (isBulk) {
        console.log("dfg");
        
        // Bulk site change
        if (this.state.selectedSubAssemblies.length === 0) {
            toast.error("No sub assemblies selected", {
                position: toast.POSITION.TOP_RIGHT,
            });
            return;
        }
        
        this.setState({ saveFormSubmitting: true });
        
        const data = {
            ids: this.state.selectedSubAssemblies,
            site_id: this.state.bulkChangeSiteForm.site_id,
            transfer_date: this.state.bulkChangeSiteForm.transfer_date,
            remark: this.state.bulkChangeSiteForm.remark
        };
        
        HttpAPICall.withAthorization(
            'PUT', 
            IAM_API_BASE_URL_2 + '/multiple_sub_assembly/site_change', 
            this.props.access_token, 
            null, 
            data, 
            (response) => {
                toast.success(response.data.msg || "Site changed successfully for selected sub assemblies", { 
                    position: toast.POSITION.TOP_RIGHT 
                });
                
                this.setState({
                    bulkChangeSiteForm: {...this.bulkChangeSiteFormInit},
                    selectedSubAssemblies: [],
                    selectAll: false,
                    isBulkSiteChange: false
                });
                
                this.changeSiteModal.hide();
                this.loadListingTblData(this.state.listing_tbl_page);
            }
        ).then(() => this.setState({ saveFormSubmitting: false }));
        
    } else {
        // Single site change (existing code)
        if (this.state.subAssemblyDetail && this.state.subAssemblyDetail.enc_id) {
            this.setState({ saveFormSubmitting: true });
            const id = this.state.subAssemblyDetail.enc_id;
            const data = {...this.state.changeSiteForm};
            
            HttpAPICall.withAthorization(
                'PUT', 
                IAM_SUBASSEMBLY_URL + '/site_change/' + id, 
                this.props.access_token, 
                null, 
                data, 
                (response) => {
                    toast.success(response.data.msg, { position: toast.POSITION.TOP_RIGHT });
                    
                    this.setState({
                        changeSiteForm: {...this.changeSiteFormInit},
                        isBulkSiteChange: false
                    });
                    console.log("gh");
                    
                    this.viewSubAssembly(id, 'minimize');
                    this.loadListingTblData();
                    this.changeSiteModal.hide();
                }
            ).then(() => this.setState({ saveFormSubmitting: false }));
        }
    }
}
renderSubAssemblyeNames = () => {
        if (this.state.selectedSubAssemblies.length === 0) return "-";
        const selectedItems = this.state.sub_assembly_listing.filter(
            item => this.state.selectedSubAssemblies.includes(item.enc_id)
        );

        if (selectedItems.length === 0) return "-";

        const firstTwoNames = selectedItems.slice(0, 2).map(item =>
            item.name || item.card_number || 'Unknown'
        ).join(', ');

        const remainingCount = selectedItems.length - 2;

        if (remainingCount > 0) {
            return `${firstTwoNames} +${remainingCount} more`;
        }

        return firstTwoNames;
    };
   siteChangeModalJsx = () => {
    const isBulk = this.state.isBulkSiteChange;
    const formData = isBulk ? this.state.bulkChangeSiteForm : this.state.changeSiteForm;
    const selectedCount = this.state.selectedSubAssemblies?.length;
    const subAssemblyName = this.state.subAssemblyDetail ? this.state.subAssemblyDetail.name : '';
    const currentSite = this.state.subAssemblyDetail && this.state.subAssemblyDetail.site ? 
                        this.state.subAssemblyDetail.site.site_name : '';
    const currentTransferDate = this.state.subAssemblyDetail && this.state.subAssemblyDetail.site_since_date ? 
                                DateService.dateTimeFormat(this.state.subAssemblyDetail.site_since_date, 'DD-MMM-YYYY') : '';
    
    return (
        <div className="modal fade" id="changeSiteModal" tabIndex="-1">
            <div className="modal-dialog modal-lg">
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title" id="changeSiteModalLabel">
                            {isBulk ? 'Bulk Change Site for Sub Assemblies' : 'Change Linked Site'}
                        </h5>
                        <button 
                            type="button" 
                            className="btn-close" 
                            data-bs-dismiss="modal" 
                            aria-label="Close"
                            onClick={() => {
                                this.setState({
                                    changeSiteForm: {...this.changeSiteFormInit},
                                    bulkChangeSiteForm: {...this.bulkChangeSiteFormInit},
                                    isBulkSiteChange: false
                                });
                            }}
                        ></button>
                    </div>
                    <form onSubmit={this.submitChangeSiteForm}>
                        <div className="modal-body">
                            {isBulk ? (
                                <>
                                    <div className="row mb-3">
                                        <label className="col-sm-3 col-form-label col-form-label-sm">
                                            Selected Sub Assemblies
                                        </label>
                                        <div className="col-sm-9">
                                            <input
                                                type="text"
                                                className="form-control form-control-sm"
                                                disabled={true}
                                                value={this.renderSubAssemblyeNames()}
                                            />
                                        </div>
                                    </div>
                                </>
                            ) : (
                                // Single Site Change Fields
                                <>
                                    <div className="row mb-3">
                                        <label className="col-sm-3 col-form-label col-form-label-sm">Sub Assembly</label>
                                        <div className="col-sm-9">
                                            <input
                                                type="text"
                                                name="name"
                                                className="form-control form-control-sm"
                                                placeholder="Sub Assembly"
                                                autoComplete="off"
                                                disabled={true}
                                                value={subAssemblyName}
                                            />
                                        </div>
                                    </div>
                                    <div className="row mb-3">
                                        <label className="col-sm-3 col-form-label col-form-label-sm">Current Site</label>
                                        <div className="col-sm-9">
                                            <input
                                                type="text"
                                                name="site"
                                                className="form-control form-control-sm"
                                                placeholder="Current Site"
                                                autoComplete="off"
                                                disabled={true}
                                                value={currentSite}
                                            />
                                        </div>
                                    </div>
                                    <div className="row mb-3">
                                        <label className="col-sm-3 col-form-label col-form-label-sm">Current Transfer Date</label>
                                        <div className="col-sm-9">
                                            <input
                                                type="text"
                                                name="current_transfer_date"
                                                className="form-control form-control-sm"
                                                placeholder="Site Since Date"
                                                autoComplete="off"
                                                disabled={true}
                                                value={currentTransferDate}
                                            />
                                        </div>
                                    </div>
                                </>
                            )}
                            
                            {/* Common Fields for both */}
                            <div className="row mb-3">
                                <label className="col-sm-3 col-form-label col-form-label-sm require">Site</label>
                                <div className="col-sm-9">
                                    <TapSelect
                                        options={this.state.siteList}
                                        changeEvent={(selectedOption) => {
                                            const formName = isBulk ? 'bulkChangeSiteForm' : 'changeSiteForm';
                                            this.tapSelectChange(selectedOption, formName, 'site_id');
                                        }}
                                        isSearchable={true}
                                        isClearable={true}
                                        menuPlacement="bottom"
                                        placeholder="Select Site"
                                        containerHeight="30px"
                                        fontSize="93%"
                                        required={true}
                                        value={this.state.siteList.find(s => formData.site_id === s.value)}
                                    />
                                </div>
                            </div>
                            
                            <div className="row mb-3">
                                <label className="col-sm-3 col-form-label col-form-label-sm require">Transfer Date</label>
                                <div className="col-sm-9">
                                    <DatePicker
                                        selected={
                                            formData.transfer_date
                                                ? moment(formData.transfer_date).toDate()
                                                : false
                                        }
                                        name="transfer_date"
                                        onChange={(value) => {
                                            const formName = isBulk ? 'bulkChangeSiteForm' : 'changeSiteForm';
                                            this.formDateHandler('transfer_date', value, formName, 'YYYY-MM-DD HH:mm:ss');
                                        }}
                                        dateFormat="dd-MMM-yyyy hh:mm a"
                                        className={"form-control form-control-sm"}
                                        showMonthDropdown
                                        showYearDropdown
                                        showTimeSelect
                                        timeIntervals={5}
                                        timeCaption="Time"
                                        autoComplete="off"
                                        scrollMonthYearDropdown
                                        required={true}
                                        maxDate={new Date()}
                                        placeholderText="Please Enter Date of Transfer"
                                    />
                                </div>
                            </div>
                            
                            <div className="row mb-3">
                                <label className="col-sm-3 col-form-label col-form-label-sm">Remark</label>
                                <div className="col-sm-9">
                                    <textarea
                                        name="remark"
                                        onChange={(e) => {
                                            const formName = isBulk ? 'bulkChangeSiteForm' : 'changeSiteForm';
                                            this.formInputHandler(e, formName);
                                        }}
                                        className="form-control"
                                        placeholder="Please Add Remark"
                                        style={{ height: "100px" }}
                                        value={formData.remark}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="modal-footer">
                            <button 
                                type="button" 
                                disabled={this.state.saveFormSubmitting} 
                                className="btn btn-secondary" 
                                data-bs-dismiss="modal"
                                onClick={() => {
                                    this.setState({
                                        changeSiteForm: {...this.changeSiteFormInit},
                                        bulkChangeSiteForm: {...this.bulkChangeSiteFormInit},
                                        isBulkSiteChange: false
                                    });
                                }}
                            >
                                Close
                            </button>
                            <button 
                                type="submit" 
                                disabled={this.state.saveFormSubmitting} 
                                className="btn btn-primary mx-2"
                            >
                                {isBulk ? 'Update All' : 'Save'} 
                                {this.state.saveFormSubmitting ? (
                                    <TapIcon.FontAwesomeIcon icon={TapIcon.faSyncAlt} className="fa-spin" />
                                ) : ''}
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
}

    linkAssetModalInit = (type= '') => {
        let asset_id = this.state.subAssemblyDetail && this.state.subAssemblyDetail.asset_profile ? this.state.subAssemblyDetail.asset_profile.asset_id : ''
        this.linkAssetModalRef.current.linkAssetModalInit(this.state.subAssemblyDetail,type,asset_id)   
    }
   
    render                              =   ()  =>  {
        return (<ApplicationLayout>
        <Helmet><title>Sub Assembly Listing</title></Helmet>
            {this.subAssemblyListjsx()}
            {this.subAssemblySearchModalJsx()}
            {this.statusChangeModalJsx()}
            {this.siteChangeModalJsx()}
            {this.assetBulkUploadModalJsx()}
            <LinkingModal 
                ref={this.linkAssetModalRef} 
                afterSubmitForm={(id, type) => {
                    if (type === 'bulk') {
                        this.loadListingTblData(this.state.listing_tbl_page);
                    } else if (id) {
                        this.viewSubAssembly(id, 'minimize');
                        this.loadListingTblData(1);
                    } else {
                        this.loadListingTblData(this.state.listing_tbl_page);
                    }
                }}
            />
        </ApplicationLayout>);
    }

}


const mapStateToProps = state => {
    return {
        access_token            :   state.auth.access_token,
        iam_user_sites          :   state.app && state.app.user_sites ? state.app.user_sites : [],
        iam_asset_types         :   state.app && state.app.asset_type ? state.app.asset_type : [],
        asset_groups            :   state.app && state.app.asset_groups ? state.app.asset_groups : [],
        permissions             :   state.app.acl_info && state.app.acl_info.permissions && state.app.acl_info.permissions.length > 0 ? state.app.acl_info.permissions : [],
    };
};

export default connect(mapStateToProps)(SubAssemblyList);